<script lang="ts" setup>
import RexSortFieldV3 from '@/rex-components/RexSortFieldV3.vue';
import RexFilterFieldV3 from '@/rex-components/RexFilterFieldV3.vue';
import { anomalyFilterOptions } from '@/components/charts/utils/utils.config';

interface Props {
  selectedFilters: string[];
}
const props = defineProps<Props>();
const emit = defineEmits(['onAnomalySort', 'onAnomalyFilter']);
</script>

<template>
  <div class="anmly-side-bar-actions-box">
    <RexFilterFieldV3
      :initialSelectedKeys="props.selectedFilters"
      :items="anomalyFilterOptions"
      @onFilter="(selectedKeys) => emit('onAnomalyFilter', selectedKeys)"
      class="anmly-side-bar-filter-action"
    />
    <RexSortFieldV3 @onSortChange="(isAsc) => emit('onAnomalySort', isAsc)" />
  </div>
</template>

<style lang="scss" scoped>
.anmly-side-bar-actions-box {
  @include flex-center-vert;
}
.anmly-side-bar-filter-action {
  margin-right: 0.5rem;
}
</style>
